// add loader and disabled class to gform submits to prevent multiple submits
$('.gform_wrapper form').on('submit', function (e) {
    let $submit = $(this).closest('.gform_wrapper').find('.gform_footer *[type="submit"]');

    if (!$submit.hasClass('btn-disabled')) {
        $submit.addClass('btn-disabled').prepend('<i class="icon-left fas fa-spinner fa-spin"></i>').blur();
    } else {
        e.preventDefault();
    }
});


// hide .gform_heading if .gform_description is only child and is empty
$('.gform_wrapper .gform_heading .gform_description').each(function () {
    let $heading = $(this).closest('.gform_heading');
    let $description = $(this);

    // if description is empty
    if ($description.html() === '') {

        // if description is empty, and only child, remove heading
        if ($description.siblings().length < 1) {
            $heading.remove();
        }

        // remove empty description
        $description.remove();
    }
});

// check limit if forms have available entries
let $checkAvailability = $('.gf-check-availability');
if ($checkAvailability.length) {
    const formId = $checkAvailability.data('form-id');

    // check if form has available entries
    // rest api route returns entry limit notification
    $.ajax({
        type: 'GET',
        url: resturl + 'gravity-forms/check-availability',
        data: { id: formId }
    }).done(function(data) {

        // check if response is valid
        if (data.notification) {
            // if notification is present
            let $limit = $checkAvailability.find('.limit'),
                $notification = $checkAvailability.find('.notification');
            $limit.append(data.notification);

            if (!$notification.is(':visible')) {
                // show notification
                $notification.css('display', 'flex'); 
            }
        }
    }).always(function() {
        // toggle loader off
        $checkAvailability.find('.loader').hide(); 
    });
}